import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularFireModule, FIREBASE_OPTIONS } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { AppConfigService } from '@elio/emanager-front/shared/app-config';

@NgModule({
  imports: [CommonModule, AngularFireModule, AngularFireMessagingModule],
  providers: [
    {
      provide: FIREBASE_OPTIONS,
      useFactory: (appConfigService: AppConfigService) => appConfigService.getFirebaseConfig(),
      deps: [AppConfigService],
    },
  ],
})
export class ElioMessagingPushModule {}
